// import { getPatientsForm, getPatientsFormById,  } from '../apis/patientFormSlice'
// import React, { useEffect, useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Box,
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { useDispatch, useSelector } from 'react-redux';
// import { getPatientsForm } from '../apis/patientFormSlice';
// import moment from 'moment';

// const HistoryDialog = ({ open, onClose, patientId }) => {
//   const dispatch = useDispatch();
//   const { patientsForm } = useSelector((state) => state.patientFormData);
//   const [grouped, setGrouped] = useState([]);

//   useEffect(() => {
//     if (open && patientId) {
//       dispatch(getPatientsForm({ patient: patientId, page: 0, pageSize: 200 }));
//     }
//   }, [open, patientId, dispatch]);

//   useEffect(() => {
//     if (patientsForm && patientsForm.length) {
//       const map = patientsForm.reduce((acc, item) => {
//         const d = item && item.date ? moment(item.date).format('DD-MM-YYYY') : 'Unknown Date';
//         acc[d] = acc[d] || [];
//         acc[d].push(item);
//         return acc;
//       }, {});

//       const arr = Object.keys(map)
//         .sort((a, b) => moment(b, 'DD-MM-YYYY').unix() - moment(a, 'DD-MM-YYYY').unix())
//         .map((date) => ({ date, items: map[date] }));

//       setGrouped(arr);
//     } else {
//       setGrouped([]);
//     }
//   }, [patientsForm]);

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle>Patient History</DialogTitle>
//       <DialogContent dividers>
//         {patientId ? (
//           grouped.length ? (
//             grouped.map((g) => (
//               <Accordion key={g.date} sx={{ mb: 1 }}>
//                 <AccordionSummary expandIcon={<ExpandMoreIcon />}> 
//                   <Typography sx={{ fontWeight: 600 }}>
//                     {g.date} — {g.items.length} record{g.items.length > 1 ? 's' : ''}
//                   </Typography>
//                 </AccordionSummary>
//                 <AccordionDetails>
//                   {g.items.map((it) => (
//                     <Box key={it._id} sx={{ mb: 2, borderBottom: '1px dashed #eee', pb: 1 }}>
//                       <Typography variant="subtitle2">{it.treatment || '—'}</Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         C/C: {it.cc || '—'} • Doctor: {it.doctor?.name || '—'}
//                       </Typography>
//                       {it.prescriptions && it.prescriptions.length > 0 && (
//                         <Box sx={{ mt: 1 }}>
//                           {it.prescriptions.map((p, idx) => (
//                             <Typography key={idx} variant="body2">
//                               {p.name || p.medname || p.med || 'Medicine'}{p.dosage ? ` — ${p.dosage}` : ''}
//                             </Typography>
//                           ))}
//                         </Box>
//                       )}
//                     </Box>
//                   ))}
//                 </AccordionDetails>
//               </Accordion>
//             ))
//           ) : (
//             <Typography>No history found for this patient.</Typography>
//           )
//         ) : (
//           <Typography>Select a saved patient to view history.</Typography>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default HistoryDialog;
import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider,
  Grid,
  CircularProgress,
  Chip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getPatientHistory } from '../apis/patientFormSlice';

/* ===============================
   HELPERS
================================ */
const formatLabel = (key) =>
  key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase());

const renderValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      if (value.length === 0) return '—';
      return value.map((v) => renderValue(v)).join(', ');
    }
    // For nested objects, convert to readable string
    return Object.entries(value)
      .map(([k, v]) => `${formatLabel(k)}: ${renderValue(v)}`)
      .join(' | ');
  }
  return value.toString();
};

const getFormTypeColor = (formType) => {
  const colors = {
    PHYSIO: 'info',
    DENTAL: 'success',
    ESTHETIC: 'warning',
  };
  return colors[formType] || 'default';
};

/* ===============================
   COMPONENT
================================ */
const HistoryDialog = ({ open, onClose, patientId }) => {
  const dispatch = useDispatch();

  const { patientHistory = [], loading } = useSelector((state) => state.patientFormData || {});
  const [groupedHistory, setGroupedHistory] = useState([]);


  /* ===============================
     FETCH DATA
  ================================ */
  useEffect(() => {
    if (!open) return;
    if (!patientId) return;


    // fetch only when dialog is open and patientId is available
    dispatch(getPatientHistory(patientId))
      .then((res) => console.log('getPatientHistory result:', res && res.payload ? res.payload.data?.length : res))
      .catch((err) => console.error('getPatientHistory error:', err));
  }, [open, patientId, dispatch]);

  /* ===============================
     GROUP BY DATE
  ================================ */
  useEffect(() => {
    const source = patientHistory;
    if (!source || !source.length) {
      setGroupedHistory([]);
      return;
    }

    const grouped = source.reduce((acc, item) => {
      const dateKey = (item.date || item.createdAt)
        ? moment(item.date || item.createdAt).format('DD-MM-YYYY')
        : 'Unknown Date';

      acc[dateKey] = acc[dateKey] || [];
      acc[dateKey].push(item);
      return acc;
    }, {});

    const result = Object.keys(grouped)
      .sort(
        (a, b) =>
          moment(b, 'DD-MM-YYYY').valueOf() -
          moment(a, 'DD-MM-YYYY').valueOf()
      )
      .map((date) => ({
        date,
        records: grouped[date],
      }));

    setGroupedHistory(result);
  }, [patientHistory]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
          border: '1px solid var(--color-border-soft)',
        },
      }}
    >
      <DialogTitle
        sx={{
          py: 1.1,
          px: 1.5,
          fontSize: '1rem',
          fontWeight: 700,
          color: 'var(--color-heading)',
          borderBottom: '1px solid var(--color-border-soft)',
          background: '#f8fbff',
        }}
      >
        Patient History
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          p: 1.25,
          backgroundColor: '#fcfdff',
          '& .MuiTypography-root': { fontSize: '0.82rem' },
        }}
      >
        {!patientId && (
          <Typography>Save the assessment first to view history.</Typography>
        )}

        {patientId && loading && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
            <CircularProgress size={20} />
            <Typography>Loading history...</Typography>
          </Box>
        )}

        {patientId && !loading && !groupedHistory.length && (
          <Typography>No previous assessments found for this patient.</Typography>
        )}

        {patientId && !loading && groupedHistory.map((group) => (
          <Accordion
            key={group.date}
            defaultExpanded
            sx={{
              mb: 1,
              borderRadius: '8px !important',
              border: '1px solid var(--color-border-soft)',
              boxShadow: 'none',
              '&:before': { display: 'none' },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: 2 }}>
                <Typography sx={{ fontWeight: 700, color: 'var(--color-heading)' }}>{group.date}</Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  {group.records && group.records[0] && (
                    <Chip 
                      label={group.records[0].formType || 'PHYSIO'} 
                      color={getFormTypeColor(group.records[0].formType)} 
                      size="small" 
                    />
                  )}
                  <Typography variant="body2" color="text.secondary">
                    {group.records.length} record{group.records.length > 1 ? 's' : ''}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ pt: 0.5 }}>
              {group.records.map((item) => (
                <Box
                  key={item._id}
                  mb={1.25}
                  sx={{
                    p: 1.2,
                    backgroundColor: '#f9fbff',
                    borderRadius: 1,
                    border: '1px solid var(--color-border-soft)',
                  }}
                >
                  {/* Header with Form Type and Date */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.2 }}>
                    <Box>
                      <Chip 
                        label={item.formType || 'PHYSIO'} 
                        color={getFormTypeColor(item.formType)} 
                        size="small" 
                        sx={{ mr: 1 }}
                      />
                      <Typography variant="caption" color="text.secondary">
                        {moment(item.date || item.createdAt).format('HH:mm A')}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Doctor & Patient Information */}
                  <Typography variant="subtitle2" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                    Doctor & Patient
                  </Typography>
                  <Divider sx={{ mb: 1 }} />

                  <Grid container spacing={1.2} mb={1.2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2">
                        <b>Doctor:</b> {item.doctor?.name || '—'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2">
                        <b>Patient:</b> {item.patient?.name || '—'}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Form-Specific Data */}
                  {item.formData && Object.keys(item.formData).length > 0 && (
                    <>
                      <Typography variant="subtitle2" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                        {item.formType || 'PHYSIO'} Assessment Details
                      </Typography>
                      <Divider sx={{ mb: 1 }} />

                      <Grid container spacing={1.2}>
                        {Object.entries(item.formData).map(([key, value]) => {
                          if (!value || value === '') return null;

                          return (
                            <Grid item xs={12} sm={6} md={4} key={key}>
                              <Typography variant="body2">
                                <b>{formatLabel(key)}:</b> {renderValue(value)}
                              </Typography>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </>
                  )}

                  {/* Other Root Level Fields */}
                  <Box sx={{ mt: 1.25 }}>
                    {item.numOfSessions && (
                      <Typography variant="body2">
                        <b>Number of Sessions:</b> {item.numOfSessions}
                      </Typography>
                    )}
                    {item.payment && (
                      <Typography variant="body2">
                        <b>Payment:</b> {item.payment}
                      </Typography>
                    )}
                    {item.paymentType && (
                      <Typography variant="body2">
                        <b>Payment Type:</b> {item.paymentType}
                      </Typography>
                    )}
                  </Box>

                  {/* Prescriptions */}
                  {Array.isArray(item.prescriptions) && item.prescriptions.length > 0 && (
                    <>
                      <Typography variant="subtitle2" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                        Prescriptions
                      </Typography>
                      <Divider sx={{ mb: 1 }} />
                      {item.prescriptions.map((med, idx) => (
                        <Box
                          key={idx}
                          p={1}
                          mb={0.75}
                          sx={{
                            border: '1px solid var(--color-border-soft)',
                            borderRadius: 1,
                            backgroundColor: '#fff',
                          }}
                        >
                          <Typography variant="body2">
                            <b>Medicine:</b> {med.medicine?.name || med.medicineName || med.name || '—'}
                          </Typography>
                          <Typography variant="body2">
                            <b>Dosage:</b> {med.dosage || '—'}
                          </Typography>
                          {med.frequency && (
                            <Typography variant="body2">
                              <b>Frequency:</b> {med.frequency}
                            </Typography>
                          )}
                          {med.instruction && (
                            <Typography variant="body2">
                              <b>Instructions:</b> {med.instruction}
                            </Typography>
                          )}
                          {med.qty && (
                            <Typography variant="body2">
                              <b>Quantity:</b> {med.qty}
                            </Typography>
                          )}
                        </Box>
                      ))}
                    </>
                  )}

                  <Divider sx={{ mt: 1.25 }} />
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>

      <DialogActions sx={{ px: 1.25, py: 1, borderTop: '1px solid var(--color-border-soft)' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: 'none',
            minHeight: 32,
            px: 1.4,
            fontSize: '0.8rem',
            borderRadius: '8px',
            background: 'var(--gradient-primary)',
            boxShadow: 'none',
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HistoryDialog;
